<template>
  <div>
    <div class="tableData">
      <span>团财投保单共有<span class="num">{{ total }}笔</span></span>
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="action">
            <span class="table-btn" @click="detail(row)">详情</span>
            <div style="display:inline-block;" v-if="$units.pointAction('order_40_1_2')">
              <Tooltip content="有关联保单的订单不允许删除" style="display:inline-block;" v-if="row.policyNo" transfer>
                <span class="table-btn gray">删除</span>
              </Tooltip>
              <span @click="del(row)" class="table-btn red" v-else>删除</span>
            </div>
          </template>
        </Table>
      </div>
      <Page :total="total" :current.sync="pageNum" :page-size="5" show-total @on-change="getList"
        style="text-align: center" />
        <!-- 确认弹窗 -->
      <confirm-Modal ref="confirmModal"></confirm-Modal>
    </div>
  </div>
</template>

<script>
import confirmModal from '@/components/commons/confirmModal'
import { pageTool } from '@/api/mixins';
import { config } from './index.config.js';
export default {
  mixins: [pageTool, config],
  components: {
    confirmModal
  },
  data(){
    return{
      pageSize: 5,
    }
  },
  created(){
    this.tableData = [];
    this.getColumns();
    this.initListAjax('/buz/grouporder/read/list');
  },
  methods:{
    setListParams(params){
        params.pageSize = 5;
        params.checkInsuranceStatusList = ['0','1']
        return params;
    },
    del(item){
      this.$refs.confirmModal.open({
        title: "提示",
        content: "确定删除订单？",
      }).then(() => {
        this.$http({
          url: "/buz/grouporder/del",
          type: "GET",
          data: {
            id:item.id
          }
        }).then(res => {
          this.$notice.msg('删除订单成功');
          this.getList();
        });
      })
    },
    detail(row) {
      // 桐心企业保
      if(row.type == 1 || row.dockChannel == 3) {
        this.$http({
          url: `/buz/grouporder/detail?orderNo=${row.orderNo}`,
          type: "GET",
        }).then((res) => {
          window.open(res.data, "_blank");
        })
      }else{
        // 手动录入
        this.$router.push({
          path: '/orderManage/group/order/detail',
          query: {
            id: row.id || '',
            policyNo: row.policyNo,
            orderNo: row.orderNo,
            payType: row.payType,
            productCategory: row.productCategory,//1-团险 2-财产险 3、个险
            status: row.status,//保单状态 1-保障中 -1-退保 0-终止
          }
        })
      }      
    },
  }

}
</script>

<style lang="scss" scoped>
.tableData{
  padding: 15px 20px 20px 20px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 18px;
  color: #727C8E;
  .num{
    color: #FF5F00;
  }
  .table-box{
    margin-top: 10px;
  }
}
.table-btn{
  border-right: 1px solid #CED1D5;
  margin: 0;
  padding: 0 6px;
  line-height: 13px;
  &:last-child{
    border:0;
  }
}
</style>